<!--<h1>Hi {{currentUser.username}}!</h1>
<p>DocuEdge - Document Management Service</p>

<a routerLink="/categories" class="btn btn-link">Categories</a>
-->
<!--
<h3>All registered users:</h3>
<ul>
    <li *ngFor="let user of users">
        {{user.username}} ({{user.firstName}} {{user.lastName}})
        - <a (click)="deleteUser(user.id)" class="text-danger">Delete</a>
    </li>
</ul>

    <mat-tab-group>
        <mat-tab label="Browse">
            <app-categories></app-categories>
        </mat-tab>
        <mat-tab label="Search">
            <ng-template matTabContent>
                <app-search></app-search>    
            </ng-template>
        </mat-tab>
        <mat-tab label="Upload Files">Upload Files</mat-tab>
    </mat-tab-group>
-->    
<app-full-text-search></app-full-text-search>
